import { Logger } from '../../utilities/Logger'

class LoadingButton {
  constructor (elem) {
    if (elem == null) {
      return
    }

    this.logger = new Logger('Loading button')
    this.elem = elem
    this.loadingState = false
    this.init()
  }

  init () {
    this.logger.log('loading button initialised')
  }

  toggle () {
    if (this.loadingState) {
      this.stopLoading()
    } else {
      this.startLoading()
    }
  }

  startLoading () {
    this.loadingState = true
    this.toggleState()
  }

  stopLoading () {
    this.loadingState = false
    this.toggleState()
  }

  toggleState () {
    if (this.loadingState) {
      this.logger.log('loading started')
      this.elem.dataset.loadStatus = 'loading'
      this.elem.setAttribute('aria-disabled', 'true')
    } else {
      this.logger.log('loading stopped')
      this.elem.removeAttribute('data-load-status')
      this.elem.removeAttribute('aria-disabled')
    }
  }
}

function setupLoadingButtons () {
  const loadingButtons = document.querySelectorAll('[data-loading-button]')

  for (const loadingButton of loadingButtons) {
    const buttonInstance = new LoadingButton(loadingButton)
    // Expose the instance globally or through a variable if needed
    loadingButton.loadingButtonInstance = buttonInstance
  }
}

export {
  setupLoadingButtons
}
